<template>
  <div>
    <Draggable v-model="images" @end="onEnd" item-key="id">
      <template #item="{ element, index }">
        <div class="galleria-item" >

          <img :src="getSrc(element)" style="width:calc(100% - 5px); height: auto;" @contextmenu="onImageRightClick" />

          <input type="file" style="display: none" :ref="'fileUpload' + index" @change="onFileChange(element, $event)"
            accept="image/*" />
          <span class="material-symbols-rounded plus" @click="triggerFileUpload(index)"
            :style="{ display: (getSrc(element) == null) ? 'block' : 'none' }" translate="no">add</span>

          <span class="material-symbols-rounded edit" :style="{ display: (getSrc(element) != null) ? 'block' : 'none' }"
            @click="onImageRightClick($event, element)" translate="no">edit</span>

          <ContextMenu ref="menu" :model="items" />

        </div>
      </template>
    </Draggable>
    <Button label="Save Gallery" @click="saveGallery" class="mt-3" />
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import axios from 'axios';

export default {
  components: {
    Draggable,
  },
  props: ['galleries'],
  data() {
    return {
      images: this.initializeImages(),
      items: [
        { label: 'Change', icon: 'pi pi-refresh', command: () => this.triggerFileUploadWithoutIndex() },
        { label: 'Remove', icon: 'pi pi-times', command: () => this.deleteImage() }
      ],
      selectedImage: null
    };
  },
  mounted() {
    console.log(this.galleries);
  },
  methods: {

    getImgUrl(url) {
      if (url.startsWith('http://') || url.startsWith('https://'))
        return url;
      
      return this.$socket_url+'/profiles/'+this.$socket.authKeyUnique.user_id+'/'+url;
    },
    initializeImages() {
      const placeholderCount = 9;
      const imagesFromProps = this.galleries ? this.galleries.map(url => ({ id: Date.now() + Math.random() ,url: url.image_url, file: null })) : [];
      const placeholdersNeeded = placeholderCount - imagesFromProps.length;
      const placeholders = Array.from({ length: placeholdersNeeded }, (_, id) => ({ id: Date.now() + id }));
      return [...imagesFromProps, ...placeholders];
    },
    onEnd() {
      console.log('Items reordered');
    },
    getSrc(item) {
      if (item.url) {
        return this.getImgUrl(item.url);
      } else if (item.file) {
        return URL.createObjectURL(item.file);
      } else {
        return null;
      }
    },
    async saveGallery() {
      const formData = new FormData();
      for (let index = 0; index < this.images.length; index++) {
        const element = this.images[index];
        if (element.file) {
          formData.append(`file_${index}`, element.file, element.file.name);
        }
        
        if (element.url) {
          formData.append(`url_${index}`, element.url);
        }
      }

      try {
      const response = await axios.post(this.$socket_url + '/userProfileUpdate', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': this.$socket.authKeyUnique.auth,
          'User_ID': this.$socket.authKeyUnique.user_id
        }
      });

      if (response.data.status) {
        console.log('Gallery updated successfully');
      } else {
        console.error('Gallery update failed:', response.data.error);
      } 
    } catch (error) {
        console.error('Gallery update failed:', error);
      }
    },
    onFileChange(item, e) {
      const files = e.target.files;
      if (files.length > 0) {
        const index = this.images.findIndex(i => i.id === item.id);
        if (index !== -1) {
          const updatedItem = {
            ...item,
            file: files[0],
            url: undefined
          };
          const newImages = [...this.images];
          newImages[index] = updatedItem;

          this.images = newImages;

        }
      }
    },
    triggerFileUploadWithoutIndex() {
      const id = this.selectedImage.id;
      const index = this.images.findIndex(i => i.id === id);
      console.log(this.$refs);

      this.$refs['fileUpload' + index].click();
    },
    triggerFileUpload(index) {
      this.$refs['fileUpload' + index].click();
    },
    onImageRightClick(event,element) {
      console.log(element);
      this.selectedImage = element;
      this.$refs.menu.show(event);
    },
    deleteImage() {
      console.log(this.selectedImage);
      const id = this.selectedImage.id;
      const index = this.images.findIndex(i => i.id === id);
      if (index !== -1) {
        this.images[index] = { id: Date.now() };
        const newImages = [...this.images];
        this.images = newImages;
      }
    },
  },
  watch: {
    images: {
      handler(newValue) {
        this.$emit('gallery-updated', newValue);
      },
      deep: true
    }
  }

}
</script>

<style scoped>
.galleria-item {
  height: 163px;
  width: calc(33% - 5px);
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
  background: var(--p-neutral-200);
  border-radius: 7px;
  position: relative;
}

.material-symbols-rounded.plus {
  padding: 7px;
  position: absolute;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(to top right, #fd267a, #ff6036);
  border-radius: 15px;
  color: white;
  cursor: pointer;
  font-size: 14px;
}

.material-symbols-rounded.edit {
  padding: 7px;
  position: absolute;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(to top right, #cbc7c9, #646363);
  border-radius: 15px;
  color: white;
  cursor: pointer;
  font-size: 14px;
}
</style>
